import React from 'react';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';

import store from './redux/store';
import { ColorModeProvider } from './contexts/ColorModeContext';
import AppRouter from './routes/AppRouter';
import MaintenanceGate from './components/common/MaintenanceGate';
import './styles/global.css';

function App() {
  return (
    <Provider store={store}>
      <ColorModeProvider>
        <SnackbarProvider
          maxSnack={4}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          autoHideDuration={4000}
        >
          <MaintenanceGate>
            <AppRouter />
          </MaintenanceGate>
        </SnackbarProvider>
      </ColorModeProvider>
    </Provider>
  );
}

export default App;
